jQuery(document).ready(function($) {

  $('.bar-top-menu-toggle').click(function() {
    if ($(this).hasClass('active')) {
      $('.bar-top-menu-wrap').slideUp();
    } else {
      $('.bar-top-menu-wrap').slideDown();
    }
    $(this).toggleClass('active');
  });

});
